import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {formatLocaleDate} from '@/dayjs'
import {StyledActivityReportInfoBanner} from './style'

type ActivityReportExistingBannerProps = {
    createdAt: string
    isBilled?: boolean
}

export const ActivityReportExistingBanner = ({createdAt, isBilled}: ActivityReportExistingBannerProps) => {
    const {t} = useTranslation()

    const titleKey = isBilled ? 'activity_report:billed_banner_title' : 'activity_report:existing_banner_title'
    const descriptionKey = isBilled
        ? 'activity_report:billed_banner_description'
        : 'activity_report:existing_banner_description'

    return (
        <StyledActivityReportInfoBanner $variant={isBilled ? 'error' : 'info'}>
            <div className="banner-header">
                <AlertCircleIcon size={16} />
                {t(titleKey)}
            </div>
            <span>{t(descriptionKey, {date: formatLocaleDate(createdAt, 'lll')})}</span>
        </StyledActivityReportInfoBanner>
    )
}
